@if(title) {
<div class="container mx-auto max-w-screen-md pt-4">
    <div class="flex items-center justify-center relative">
        <h3 class="md:text-[1.75rem] text-center">{{ title }}</h3>
    </div>
</div>
}

<div class="container mx-auto max-w-screen-md items-center flex py-6 px-2 md:px-0 empty:p-0">
    <ng-content select="[slot=progress]" />
</div>

<div #fadediv class="transition-all duration-500">
    <ng-content select="[slot=question]" />
    <div class="mx-auto pt-4 max-w-screen-md flex flex-row justify-end px-2 py-4 md:px-0 [&:has(>:nth-child(2))]:justify-between">
        <ng-content select="[slot=buttons]" />
    </div>
</div>